import * as React from 'react'
import {Button} from '@frontrow/console/src/components/button'
import {type PolyfilledEvent} from '@frontrow/console/src/polyfills'
import * as style from './upload-file-button.module.scss'

type Props = {
  buttonText: string
  onPostFileUpload: (file: File) => void
  isDisabled?: boolean
}

const defaultProps = {
  isDisabled: false
}

export class UploadFileButton extends React.Component<Props> {
  static defaultProps = defaultProps
  hiddenInputElement: HTMLInputElement | undefined | null

  uploadFile(e: PolyfilledEvent) {
    const {onPostFileUpload} = this.props
    const fileInputValue = (e.target as HTMLInputElement).files![0]
    onPostFileUpload(fileInputValue)
  }

  onButtonClick() {
    if (this.hiddenInputElement !== null && this.hiddenInputElement !== undefined) {
      //used to force onChange event to fire on every file upload even if file is the same.
      this.hiddenInputElement.value = ''
      this.hiddenInputElement.click()
    }
  }

  render(): React.ReactElement {
    const {isDisabled, buttonText} = this.props
    return (
      <div className={style.uploadInputWrapper}>
        <input
          type="file"
          onChange={this.uploadFile.bind(this)}
          ref={elem => (this.hiddenInputElement = elem)}
          className={style.inputElement}
        />
        <Button
          style="secondary"
          onClick={this.onButtonClick.bind(this)}
          disabled={isDisabled}
          dataTest="upload-file-button"
        >
          {buttonText}
        </Button>
      </div>
    )
  }
}
